import React from 'react'

export default function CompleteOAuth2Flow(params) {
  return <h1>Completing OAuth2 flow</h1>
}
